<template src="./list_item.html"></template>

<script>
import SchoolService from 'Services/SchoolService';
import Pagination from 'Components/pagination/Pagination.vue';

export default {
  components: {
    Pagination,
  },
  data() {
    return {
      schools: [],
      // pagination
      currentPage: 1,
      from: 0,
      to: 0,
      total: 0,
      perPage: 12,
      lastPage: 1,
      isLoading: true,
      i18n: 2,
      type_contact: null,
    };
  },

  created() {
    this.listt();
  },

  methods: {
    convertHTML(value) {
      if (value) {
        if (value.length < 100) {
          return `${value.replace(/(<([^>]+)>)/g, '')}`;
        }
        return `${value.replace(/(<([^>]+)>)/g, '').substring(0, 100)}...`;
      }

      return '';
    },
    ready(event) {
      this.player = event.target;
    },
    stop() {
      this.player.stopVideo();
    },
    pause() {
      this.player.pauseVideo();
    },
    listt() {
      this.isLoading = true;
      if (localStorage.getItem('lang') === 'ja') {
        this.i18n = 1;
      }
      this.type_contact = this.$route.params.type_contact;

      const params = {
        page: this.currentPage,
        limit: this.perPage,
        type_contact: this.type_contact,
        i18n: this.i18n,
      };

      SchoolService.listItem(params)
        .then((response) => {
          this.schools = response.data.data;
          this.from = response.data.from;
          this.to = response.data.to;
          this.total = response.data.total;
          this.lastPage = response.data.last_page;
        })
        .catch(() => {});
    },

    onPageChange(page) {
      this.currentPage = page;
      this.list();
    },
  },
};
</script>
